import {isTouched, music} from "./index";
import {trackError} from "../../store/log/actions";
import { getStore } from "../..";

const BACKGROUND_VOLUME = 0.4;

let timer: number;
let currentSprite: string;
export let currentBackgroundMusicId: number = 0;

export default function playBackground(name: string, fadeOutTime = 100, fadeInTime = 300) {
    if (!isTouched) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = window.setTimeout(() => playBackground(name, fadeOutTime, fadeInTime), 300);
    }

    if (name === currentSprite)
        return;

    try {
        if (currentBackgroundMusicId > 0) {
            const fadeId = currentBackgroundMusicId;
            music.fade(BACKGROUND_VOLUME, 0, fadeOutTime, fadeId);
            music.once('fade', () => {
                music.stop(fadeId);
            }, fadeId);
        } else if (music.playing()) {
            music.stop();
        }

        const soundId = music.play(name);
        music.once('play', () => {
            music.fade(0, BACKGROUND_VOLUME, fadeInTime, soundId);
        }, soundId);

        currentSprite = name;
        currentBackgroundMusicId = soundId;
    }
    catch (error) {
        const store = getStore();
        store && store.dispatch(trackError({
            category: "playBackground",
            message: "Failed to play sound sprite",
            error: error,
            data: {
                sprite: name,
            }
        }))
    }
}